<template>
    <div class="help">
    	<HeaderTop :activeIndex="activeIndex"></HeaderTop>
		<div class="help-bannerbox">
			<img src="../../assets/bannerHelp_2.png" class="bannerbox-banner">
		</div>
		<div class="help-content">
      <div class="content">
        <h1 style="text-align: center"></h1>
      </div>
			<div class="content">
				<h4 class="title">问：成教学生端登录地址是什么？</h4>
				<p class="text">答：https://adult-study.whxunw.com/#/login</p>
			</div>
			<div class="content">
				<h4 class="title">问：有小程序登录吗</h4>
				<p class="text">答：在登录页右上方有微信扫码访问即可。</p>
			</div>
			<div class="content">
				<h4 class="title">问：登录的账号和密码是什么</h4>
				<p class="text">答：账号是：身份证号<br>密码是：身份证后6位</p>
			</div>
      <div class="content">
				<h4 class="title">问：为什么我登录后的页面显示不完整</h4>
				<p class="text">答：用谷歌浏览器登录试下，或者把页面字体缩小试下</p>
			</div>
      <div class="content">
				<h4 class="title">问：登录平台我需要做什么</h4>
				<p class="text">答：根据主考学校的教学计划安排，在规定的时间段内完成学习、平时作业、考试</p>
			</div>
      <div class="content">
				<h4 class="title">问：为什么电脑登录，人脸比对的时候不弹出画面</h4>
				<p class="text">答：确保电脑有摄像头，功能使用正常的情况下，如果系统弹出是否允许使用摄像头，点允许就可以了</p>
			</div>
      <div class="content">
				<h4 class="title">问：视频能拖动快速看完吗</h4>
				<p class="text">答：学习过程中不能拖动，视频看完回看可以拖动</p>
			</div>
      <div class="content">
				<h4 class="title">问：作业只能做1次吗，做错了可以重做吗</h4>
				<p class="text">答：作业在规定的时间内可以重复做，不限次数，直至做到满分</p>
			</div>
      <div class="content">
				<h4 class="title">问：考试试卷可以像作业一样重复做吗</h4>
				<p class="text">答：考试试卷有次数限制，根据学校的通知决定，请在规定的次数内认真作答</p>
			</div>
      <div class="content">
				<h4 class="title">问：考试中途电脑死机或断网了怎么办，还能再进吗</h4>
				<p class="text">答：重启电脑或连上网络后重新登录，可以继续上次未完成的作答。需在试卷开始作答----结束时间内（一般是120分钟），如果考试时间结束后再登录，也无法继续考试</p>
			</div>
		</div>
        <Footer></Footer>
	</div>
</template>

<script>
import HeaderTop from "./HeaderTop.vue";
import Footer from "./Footer.vue";

export default {
    name: 'Help',
    components: {
        HeaderTop,
		Footer
    },
	data() {
		return {
			activeIndex: 'newyear-help',
		};
	},
	methods: {

	},
}
</script>

<style lang="scss" scoped>
::v-deep(.header-top .nav){
  background-color: #930B00;
  position: initial;
}
.help {
	.help-bannerbox {
		width: 1200px;
		margin: 0 auto;
		height: 340px;
		.bannerbox-banner {
			display: block;
			width: 1200px;
			height: 340px;
		}
	}
	.help-content {
		width: 1200px;
		margin: 0 auto;
		.content {
			// margin: 20px 0;
			padding: 0 30px 20px 30px;
			background-color: #FFFFFF;
			.title {
				font-size: 20px;
				color: #333333;
				line-height: 40px;
				font-weight: 700;
			}
			.text {
				font-size: 16px;
				// color: #999999;
				line-height: 28px;
			}
		}
	}
}
</style>
